const initialState = {
  loading: false,
  results: [],
  error: null,
  notification: null,
};

const wishlistReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'WISHLIST_FETCH_REQUEST':
      return { ...state, loading: true };

    case 'WISHLIST_FETCH_SUCCESS':
      return { loading: false, results: action.payload.results, error: null, notification: null };

    case 'WISHLIST_FETCH_FAIL':
      return { loading: false, results: [], error: action.payload, notification: null };

    case 'WISHLIST_ADD_REQUEST':
      return { ...state, loading: true, notification: null };

    case 'WISHLIST_ADD_SUCCESS':
      if (action.payload?.product) {
        return {
          ...state,
          loading: false,
          results: [...state.results, action.payload.product],
          error: null,
          notification: 'Added to wishlist!',
        };
      } else if (action.payload?.message) {
        return {
          ...state,
          loading: false,
          error: null,
          notification: action.payload.message,
        };
      } else {
        return {
          ...state,
          loading: false,
          error: null,
          notification: 'Wishlist updated.',
        };
      }

    case 'WISHLIST_ADD_FAIL':
      return {
        ...state,
        loading: false,
        error: action.payload,
        notification: null,
      };

    case 'WISHLIST_DELETE_SUCCESS':
      return {
        ...state,
        results: state.results.filter(item => item.wishlist_id !== action.payload),
        notification: 'Removed from wishlist.',
      };

    case 'WISHLIST_DELETE_FAIL':
      return { ...state, error: action.payload };

    case 'WISHLIST_NOTIFICATION_CLEAR':
      return { ...state, notification: null };

    default:
      return state;
  }
};

export default wishlistReducer;
